export const firebaseConfig = {
    apiKey: "AIzaSyA2tA4K85vQiwnIGCEo1qfCR-wKM2w-NRU",
    authDomain: "web--reviews.firebaseapp.com",
    projectId: "web--reviews",
    storageBucket: "web--reviews.appspot.com",
    messagingSenderId: "908980528649",
    appId: "1:908980528649:web:309aadd4935f8829253ad8"
};
